import { Dropdown, MenuItem } from 'react-bootstrap';

import { window } from '../../globals';
import { DocsLink, NEW_TAB_PROPS, SupportLink } from '../generic/Link';
import { getDocsUrl } from '../generic/Link/DocsLink';
import { mailToUrl } from '../generic/Link/MailToLink';

const SUPPORT_CONFIG = window.support;

const Docs = () => <DocsLink to="/">Docs</DocsLink>;

/**
 * Renders a Support link. Either a docs link, if support is not enabled.
 * Or a dropdown with a docs link and a contact us link.
 */
const SupportDropdown = () => {
  if (!window.user) {
    return null;
  }

  if (!SUPPORT_CONFIG.enabled) {
    return (
      <li className="nav-right" key="nav-link-docs">
        <Docs />
      </li>
    );
  }

  const supportUrl = SUPPORT_CONFIG.type === 'email'
    ? mailToUrl(SUPPORT_CONFIG.email)
    : SUPPORT_CONFIG.url;

  return (
    <li className="nav-right link-dropdown-right" key="nav-link-support">
      <Dropdown id="support-nav-dropdown" pullRight>
        <Dropdown.Toggle useAnchor />
        <Dropdown.Menu className="nav-support-dropdown">
          {/* eslint-disable-next-line react/jsx-props-no-spreading -- This is intended to be spread */}
          <MenuItem key="docs" href={getDocsUrl('/')} {...NEW_TAB_PROPS}>
            Docs
          </MenuItem>
          <MenuItem key="contact" href={supportUrl}>
            Contact Us
          </MenuItem>
        </Dropdown.Menu>
      </Dropdown>
      <SupportLink>
        Support
      </SupportLink>
    </li>
  );
};

export default SupportDropdown;
